import { Component, Input, forwardRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { DropdownFieldModel } from '../../../models/dropdown-field.model';
import { DropdownOptionModel } from '../../../../Forms/models/dropdown-option.model';


@Component({
    selector: 'agpr-dropdown-field',
    templateUrl: './dropdown-field.component.html',
    styleUrls: ['./dropdown-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => DropdownFieldComponent)
        },
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: DropdownFieldComponent
        }
    ],
    standalone: false
})
export class DropdownFieldComponent extends AbstractFormFieldComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() declare field: DropdownFieldModel;
    @Input() inputTooltip: string;
    @Input() labelClass: string = '';
    @Input() set updateOptions(x) {
        this.options = this.field.options.slice();
        this.setSelectedOption();
    }

    options: DropdownOptionModel[] = [];
    selectedOption: DropdownOptionModel = null;
    ariaLabel: string;
    showDropdown: boolean = true;

    ngOnInit(): void {
        this.options = this.field.options.slice();
        this.setSelectedOption();
    }

    writeValue(value: any): void {
        this.value = value;
        this.setSelectedOption();
    }

    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    registerOnChange(fn): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }

    onDropdownChanged(value: any) {
        this.value = value;
        this.onModelChange(this.value);
        this.changes.emit(this.value);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.field.changeOption && this.options.length > 0) {
            this.field.changeOption.bind(this);
            this.field.changeOption(this, changes);

            return;
        }

        if (!this.shouldShowDropdown() || changes?.value?.previousValue === changes?.value?.currentValue) {
            return;
        }

        if (!this.value) {
            return;
        }

        this.setSelectedOption();
    }

    setSelectedOption(): void {
        if (this.options && this.options.length > 0) {

            this.options.forEach(option => {
                if (option.value === this.value) {
                    this.selectedOption = option;
                }
            });

            if (!this.selectedOption) {
                // by default, select the first option
                this.selectedOption = this.options[0];
                this.onDropdownChanged(this.selectedOption.value);
            }

            this.ariaLabel = this.field.ariaLabel;
            if (!this.ariaLabel) {
                this.ariaLabel = this.selectedOption.label;
            }
        }
    }

    shouldShowDropdown(): boolean {
        if (!this.block) {
            return this.showDropdown;
        }

        if (this.field.appearCondition) {
            this.showDropdown = this.field.appearCondition(this.block.displayElement);
        }

        return this.showDropdown;
    }
}
